import axios from "axios";

export function addUsersToGroups(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/addUsersToGroup`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function grantGroupPermissions(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/grantGroupPermissions`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
